import React from 'react';
import styled from '@emotion/styled';
import { ImageTexts } from '..';

export const IconTexts = () => {
  return (
    <StyledIconTextsSpan className="icon-svg IconTexts">
      {/* <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <defs />
        <g className="a">
          <rect className="b" width="24" height="24" />
          <text className="c" transform="translate(1 18)">
            <tspan x="0" y="0">
              􀅒
            </tspan>
          </text>
        </g>
      </svg> */}
      <img src={ImageTexts} alt="" />
    </StyledIconTextsSpan>
  );
};

const StyledIconTextsSpan = styled.span`
  & .a {
    opacity: 0.7;
  }

  & .b {
    fill: none;
  }

  & .c {
    fill: #fff;
    font-size: 16px;
    font-family: SF Pro;
  }

  display: inline-block;
  vertical-align: sub;

  & img {
    vertical-align: sub;
    border-style: none;
  }
`;
